/**
 * Referral API
 *
 * Endpoints:
 *   GET api/v1/referral/stats - getStats
 */
import { apiClientGetRequest } from '../lib/backendRequest';

const referralApi = (accessToken) => ({
  /**
   * Referral usage and earned credit of the signed-in user. `used` counts paid orders with the
   * code against `limit`, `credits` are the payouts made when a friend's order shipped, newest
   * first.
   *
   * @returns {Promise<{ data?: {
   *   referralCode: string,
   *   limit: number,
   *   used: number,
   *   remaining: number,
   *   enabled: boolean,
   *   creditPerReferral: number,
   *   earned: { amount: number, currency: string },
   *   credits: Array<{ id: number, amount: number, currency: string, createdAt: string }>,
   * }, error?: any }>}
   */
  async getStats() {
    try {
      const response = await apiClientGetRequest('api/v1/referral/stats', {
        Authorization: `Token ${accessToken}`,
      });
      const { data } = await response.json();

      return {
        data: {
          referralCode: data.referral_code,
          limit: data.limit,
          used: data.used,
          remaining: data.remaining,
          enabled: data.enabled,
          creditPerReferral: data.credit_per_referral,
          earned: data.earned,
          credits: data.credits.map((credit) => ({
            id: credit.id,
            amount: credit.amount,
            currency: credit.currency,
            createdAt: credit.created_at,
          })),
        },
      };
    } catch (e) {
      return { error: e.code };
    }
  },
});

export default referralApi;
